import React from 'react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-primary" data-id="element-16" data-mp="axhve37bl2g">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-17" data-mp="3iqq5rmi7ugus">
        <h2 id="beneficios" className="font-display text-[1.5rem] font-extrabold leading-[1.1] tracking-tight text-white sm:text-4xl" data-id="element-18" data-mp="3npb6dn1dr2jr">
          ¿Qué puede cambiar cuando empiezas?
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-white" data-id="element-19" data-mp="3drmzxzuew6lr">
          Estudiar con material visual puede ayudarte a comprender y organizar
          mejor la información.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-20" data-mp="34px84swmb5ng">
          {benefits.map((benefit, i) => <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-xl border-2 border-ink bg-surface p-2.5 text-left" data-id="element-21" data-mp="xzftnc3tcy0j" data-mpi={i}>
              <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-tint text-base" aria-hidden="true" data-id="element-22" data-mp="2bdusatijgic8">
                {benefit.emoji}
              </span>
              <div data-id="element-23" data-mp="2l6tkeld8ur0l">
                <h3 className="font-sub text-sm font-semibold leading-tight text-teal-hover" data-id="element-24" data-mp="2g65vc58ksk90">
                  {benefit.title}
                </h3>
                <p className="mt-0.5 text-xs leading-snug text-muted sm:text-sm" data-id="element-25" data-mp="1sgtlr49c6a66">
                  {benefit.desc}
                </p>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}